import { getAction } from "@/api/manage";
import wx from 'weixin-js-sdk'


export function wxshare(title, imgUrl, desc, link, onSuccess, onCancel) {
    var shareData = {
        title: title || document.title,
        imgUrl: imgUrl || window.location.protocol + '//' + window.location.host + '/logo.png',
        desc: desc || document.title,
        link: link || location.href
    }
    getAction('/wechatAuth/getJssdkTicket', {
        url: location.href.split('#')[0]
    }).then(res => {
        if (res.success) {
            wxconfig(res.result, shareData, onSuccess, onCancel);
        }
    })
}

// 微信setting
function wxconfig(data, shareData, onSuccess, onCancel) {
    wx.config({
        debug: false,
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名，见附录1
        jsApiList: [
            'updateTimelineShareData',
            'updateAppMessageShareData'
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });

    wx.error(res => {
        console.error("微信SDK错误", res);
        // 可在此上报具体错误信息
    });

    wx.ready(function () {
        wx.updateTimelineShareData({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.imgUrl, // 分享图标
            success: function () {
                // 用户确认分享后执行的回调函数
                if (onSuccess) {
                    onSuccess();
                }
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
                if (onCancel) {
                    onCancel();
                }
            }
        });

        wx.updateAppMessageShareData({
            title: shareData.title, // 分享标题
            desc: shareData.desc, // 分享描述
            link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareData.imgUrl, // 分享图标
            success: function () {
                // 用户确认分享后执行的回调函数
                if (onSuccess) {
                    onSuccess();
                }
            },
            cancel: function () {
                // 用户取消分享后执行的回调函数
                if (onCancel) {
                    onCancel();
                }
            }
        });
    });
}